// import { loginIcon } from "@/core/components/icons";
// import { POINTER_EVENTS } from "@/lib/common";
import { useI18n } from "@/core/i18n";
import { WelcomeScreen } from "@/core/index";
import React from "react";

import { isDrawinkPlusSignedUser } from "../app_constants";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  const { t } = useI18n();
  let headingContent;

  if (isDrawinkPlusSignedUser) {
    // headingContent = t("welcomeScreen.app.center_heading_plus")
    //   .split(/(Drawink\+)/)
    //   .map((bit, idx) => {
    //     if (bit === "Drawink Pro") {
    //       return (
    //         <a
    //           style={{ pointerEvents: POINTER_EVENTS.inheritFromUI }}
    //           href={`${
    //             import.meta.env.VITE_APP_PLUS_APP
    //           }?utm_source=drawink&utm_medium=app&utm_content=welcomeScreenSignedInUser`}
    //           key={idx}
    //         >
    //           Drawink Pro
    //         </a>
    //       );
    //     }
    //     return bit;
    //   });
    headingContent = t("welcomeScreen.app.center_heading");
  } else {
    headingContent = t("welcomeScreen.app.center_heading");
  }

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>{t("welcomeScreen.app.menuHint")}</WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo />
        <WelcomeScreen.Center.Heading>{headingContent}</WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
          {props.isCollabEnabled && (
            <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
              onSelect={() => props.onCollabDialogOpen()}
            />
          )}
          {/* {!isDrawinkPlusSignedUser && (
            <WelcomeScreen.Center.MenuItemLink
              href="/plus?utm_source=drawink&utm_medium=app&utm_content=welcomeScreenGuest"
              shortcut={null}
              icon={loginIcon}
            >
              Sign up
            </WelcomeScreen.Center.MenuItemLink>
          )} */}
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
